'use client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { NavigationGuardProvider } from 'next-navigation-guard';
import { ThemeProvider } from 'next-themes';
import { NuqsAdapter } from 'nuqs/adapters/next/app';
import posthog from 'posthog-js';
import { PostHogProvider as PHProvider } from 'posthog-js/react';
import { useEffect, useMemo } from 'react';

import { NotificationListener } from '@/components/common/notification-listener';
import { TouchProvider } from '@/components/ui/hybrid-tooltip';
import { TooltipProvider } from '@/components/ui/tooltip';

import { env } from '@/env';
import Identify from '@/posthog/identify/identify';
import PageView from '@/posthog/page-view/page-view';

type AppProviderProps = {
  children: React.ReactNode;
};

export default function AppProviders({ children }: AppProviderProps) {
  const queryClient = useMemo(() => new QueryClient(), []);
console.log('merge dev to main');

  useEffect(() => {
    if (env.NEXT_PUBLIC_POSTHOG_KEY && process.env.NODE_ENV === 'production') {
      posthog.init(env.NEXT_PUBLIC_POSTHOG_KEY, {
        api_host: '/seo-maven-ingest',
        ui_host: 'https://us.posthog.com',
        person_profiles: 'identified_only',
        defaults: '2025-05-24',
        autocapture: true,
        capture_pageview: true,
        disable_session_recording: false,
      });
    }
  }, []);

  return (
    <PHProvider client={posthog}>
      <ThemeProvider
        attribute='class'
        themes={['light', 'dark']}
        enableSystem={false}
        disableTransitionOnChange
      >
        <NuqsAdapter>
          <QueryClientProvider client={queryClient}>
            <NavigationGuardProvider>
              <TouchProvider>
                <TooltipProvider delayDuration={400}>
                  {children}
                </TooltipProvider>
              </TouchProvider>
              <NotificationListener />
              <Identify />
              <PageView />
            </NavigationGuardProvider>
          </QueryClientProvider>
        </NuqsAdapter>
      </ThemeProvider>
    </PHProvider>
  );
}
